import type { MediaRule } from "@ondit/publishing";

export function visibleDraftIssues(
	draft: { media: { type?: string; mime?: string }[]; issues?: string[]; missing_information: string[] },
	rule?: MediaRule | null,
) {
	const mediaReady =
		!!rule &&
		draft.media.length >= Math.max(1, rule.min_count ?? (rule.required ? 1 : 0)) &&
		draft.media.length <= (rule.max_count ?? (rule.multiple ? Infinity : 1)) &&
		(!rule.no_video || !draft.media.some((m) => m.type === "video" || m.mime?.startsWith("video/")));
	return [...new Set([...(draft.issues ?? []), ...draft.missing_information])].filter(
		(issue) =>
			!(mediaReady && (issue === "media_asset_required" || /图片.*(?:素材|上传)|(?:image|media) asset/i.test(issue))),
	);
}
